import { ReactNode } from 'react';

export enum FormatIconSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum FormatIconType {
  PDF = 'PDF',
  DOC = 'DOC',
  PPT = 'PPT',
  XLS = 'XLS',
  JPG = 'JPG',
  JPEG = 'JPEG',
  PNG = 'PNG',
  WEBP = 'WEBP',
  MOV = 'MOV',
  MP3 = 'MP3',
  MP4 = 'MP4',
  WEBM = 'WEBM',
  MKV = 'MKV',
  SVG = 'SVG',
  HEVC = 'HEVC',
  GENERIC = 'GENERIC',
  GENERIC_SELECTED = 'GENERIC_SELECTED',
}

export enum FormatIconFormatBg {
  PDF = '#C0381D',
  DOC = '#30A2E5',
  PPT = '#E65636',
  XLS = '#6AC157',
  JPG = '#D066F5',
  JPEG = '#D066F5',
  PNG = '#D066F5',
  WEBP = '#D066F5',
  MOV = '#9C66F5',
  MP4 = '#9C66F5',
  MP3 = '#9C66F5',
  WEBM = '#9C66F5',
  MKV = '#9C66F5',
  SVG = '#D066F5',
  HEVC = '#9C66F5',
  GENERIC = '#CBCBCB',
  GENERIC_SELECTED = '#BD99F8',
}

export enum FormatIconFormatBorderColor {
  PDF = '#7B2410',
  DOC = '#0C78A6',
  PPT = '#C02F1B',
  XLS = '#2F9634',
  JPG = '#A200EE',
  JPEG = '#A200EE',
  PNG = '#A200EE',
  WEBP = '#A200EE',
  MOV = '#5A00EE',
  MP4 = '#5A00EE',
  MP3 = '#5A00EE',
  WEBM = '#5A00EE',
  MKV = '#5A00EE',
  HEVC = '#5A00EE',
  SVG = '#A200EE',
  GENERIC = '#777778',
  GENERIC_SELECTED = '#5A00EE',
}

interface IFormatIcon {
  children?: ReactNode;
  className?: string;
  format: FormatIconType;
  foldBg?: string;
  size?: FormatIconSize;
}

export default IFormatIcon;
